<div>
  <div class="row">
    <div class="col-auto d-flex align-items-center tab-heading">
      <h2 class="h1">{{ 'academy' | translate }}</h2>
      <div class="margin-left-md seats-info">
        <span>{{ 'n_seats_provisioned' | translate: seatsTaken }}</span>
        |
        <span>{{ 'n_seats_remaining' | translate: seatsRemaining }}</span>
      </div>
    </div>
  </div>
  <div class="row mt-4">
    <div class="col-12">
      <app-tenant-academy-table
        [tenantUsers$]="tenantUsers$"
        [requestUsersReload$]="requestUsersReload$"
      ></app-tenant-academy-table>
    </div>
  </div>
</div>
